import axios from "axios";
import { listRequestBody } from "../utils/listPagination";

const BASE = "/api/permissions";

export function list(options = {}) {
  return axios.post(`${BASE}/list`, listRequestBody(options));
}

export function create(data) {
  return axios.post(BASE, data);
}

export function update(id, data) {
  return axios.patch(`${BASE}/${id}`, data);
}

export function remove(id) {
  return axios.delete(`${BASE}/${id}`);
}
